import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AppLayout } from '@/components/app-layout';
import { ApiError } from '@/config/api';
import { AuthProvider } from '@/lib/auth-context';
import { AppModalProvider } from '@/lib/modal-context';
import { CanonicalJobPage } from '@/pages/jobs/CanonicalJob';
import { PatientPage } from '@/pages/patients/Patient';
import { ProviderPage } from '@/pages/providers/Provider';
import { WorkflowRunPage } from '@/pages/workflows/WorkflowRun';
import { pages } from '@/router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof ApiError && (error.status === 401 || error.status === 403)) return false;
        return failureCount < 3;
      },
    },
  },
});

export const App = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthProvider>
        <AppModalProvider>
          <Routes>
            <Route element={<AppLayout />}>
              {pages.map(({ path, component: Component }) =>
                path === '/' ? (
                  <Route key={path} index element={<Component />} />
                ) : (
                  <Route key={path} path={path} element={<Component />} />
                )
              )}
              <Route path='/jobs/:canonicalJob' element={<CanonicalJobPage />} />
              <Route path='/patients/:patientId' element={<PatientPage />} />
              <Route path='/providers/:providerId' element={<ProviderPage />} />
              <Route path='/workflows/:runId' element={<WorkflowRunPage />} />
            </Route>
          </Routes>
        </AppModalProvider>
      </AuthProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
